import { KeyboardArrowDown } from '@mui/icons-material';
import { Button, ButtonProps, Link, MenuItem, MenuList } from '@mui/material';
import { isNotEmpty } from 'ramda';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../DataGridCustom';
import { filterInvalidLinks, ExternalLink } from '~/common/types';
import { useHoverMenu } from '~/components/HoverMenu';
import { eventStopPropagation } from '~/util/function/eventStopPropagation';

interface SourceLinksButtonProps extends Omit<ButtonProps, 'endIcon' | 'onMouseEnter' | 'onMouseLeave' | 'onClick'> {
  links?: Union.Nullable<ExternalLink[]>;
}

export const SourceLinksButton = ({ links, children, ...otherProps }: SourceLinksButtonProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SourceLinksButton' });
  const { menuOpen, menuClose, isDescendant } = useHoverMenu();
  const filteredLinks = filterInvalidLinks(links);
  const hasLinks = isNotEmpty(filteredLinks);

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    menuOpen({
      anchorEl: event.currentTarget,
      children: () => (
        <MenuList disablePadding>
          {filteredLinks &&
            filteredLinks.map((item, index: number) => (
              <MenuItem key={index} component={Link} color="inherit" target="_blank" href={item.url} rel="noreferrer">
                {item.name}
              </MenuItem>
            ))}
        </MenuList>
      ),
    });
  };
  const mouseLeave = (event: MouseEvent<any>) => {
    if (!isDescendant(event.relatedTarget as any)) {
      menuClose();
    }
  };
  if (!hasLinks) {
    return <>{NULLISH_CELL_VALUE}</>;
  }
  return (
    <Button
      sx={{ lineHeight: 'normal', color: 'text.secondary' }}
      variant="text"
      onMouseEnter={handleMenuOpen}
      onMouseLeave={mouseLeave}
      endIcon={<KeyboardArrowDown />}
      onClick={eventStopPropagation}
      {...otherProps}
    >
      {children || t('label')}
    </Button>
  );
};
